import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useMerchandiseTopBrands from 'hooks/Merchandise/useMerchandiseTopBrands'
import useMerchandiseTopCategories from 'hooks/Merchandise/useMerchandiseTopCategories'
import useRecentlyViewedMerchandise from 'hooks/Merchandise/useRecentlyViewedMerchandise'
import { take } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import MerchandiseSearchFormResultItem from './MerchandiseSearchFormResultItem'

const ResultsGrid = styled.div`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${rem(40)}
  }
`

function MerchandiseSearchFormPlaceholderResults() {
  const [brands] = useMerchandiseTopBrands()
  const [categories] = useMerchandiseTopCategories()
  const [recentlyViewed] = useRecentlyViewedMerchandise()

  const hasRecentlyViewed = !!recentlyViewed.length
  return <VerticalSpacer gap={24}>
    {hasRecentlyViewed && <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recently viewed</Caption>
      <ResultsGrid>
        {take(recentlyViewed, 3).map(merchandiseId => (
          <MerchandiseSearchFormResultItem
            key={merchandiseId}
            itemId={merchandiseId}
            type="product"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>}
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Shop by category</Caption>
      <ResultsGrid>
        {take(categories, hasRecentlyViewed ? 3 : 6).map(category => (
          <MerchandiseSearchFormResultItem
            key={category.id}
            itemId={category.id}
            type="category"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Shop by brand</Caption>
      <ResultsGrid>
        {take(brands, hasRecentlyViewed ? 3 : 6).map(brand => (
          <MerchandiseSearchFormResultItem
            key={brand.id}
            itemId={brand.id}
            type="brand"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
  </VerticalSpacer>
}

export default MerchandiseSearchFormPlaceholderResults
